import { useEffect, useState } from 'react';
import { fetchRecordings } from '../../api/fetchRecording';
import { useParams } from 'react-router';
import GetAppIcon from '@material-ui/icons/GetApp';
import { IconButton } from '@material-ui/core';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';

import styles from './styles';
import logo from './logo.png';
export default function EndCall() {
  const { push } = useHistory();
  const [recordings, setRecordings] = useState(null);
  const classes = styles();
  const { sessionId } = useParams();

  const redirectNewMeeting = () => {
    push('/');
  };
  useEffect(() => {
    fetchRecordings(sessionId)
      .then(data => {
        if (data.data) {
          setRecordings(data.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, [sessionId]);

  return (

    <div className={classes.endContainer}>
      <div className={classes.meetingInfo}>
        <h2>Thank you for attending your video visit!</h2>
      </div>
    </div>
  );
}
